(function() {
  var section = document.querySelector('[data-product-section]');
  if (!section) return;

  /* ============ Money formatting — fuente única en ThemeUtils ============ */
  var moneyFormat = section.dataset.moneyFormat;
  function formatMoney(cents) {
    return ThemeUtils.formatMoney(cents, moneyFormat);
  }

  /* ============ Gallery ============ */
  var gallery = section.querySelector('[data-product-gallery]');
  if (gallery) {
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var thumbsStrip = gallery.querySelector('[data-gallery-thumbs]');
    var currentIndex = 0;

    /* Find initial active index */
    slides.forEach(function(s, i) {
      if (s.classList.contains('is-active')) currentIndex = i;
    });

    /* Centra la miniatura activa en la tira (para que se vea su borde rojo) */
    function scrollActiveThumb(index) {
      if (!thumbsStrip || !thumbs[index]) return;
      var t = thumbs[index];
      thumbsStrip.scrollTo({
        left: t.offsetLeft - (thumbsStrip.clientWidth - t.offsetWidth) / 2,
        behavior: 'smooth'
      });
    }

    function goToSlide(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      slides.forEach(function(s) { s.classList.remove('is-active'); });
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      if (slides[index]) slides[index].classList.add('is-active');
      if (thumbs[index]) thumbs[index].classList.add('is-active');
      scrollActiveThumb(index);
      currentIndex = index;
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        goToSlide(parseInt(this.getAttribute('data-gallery-thumb')));
      });
    });

    /* Chevrons junto a las miniaturas = navegación de la galería (prev/next
       foto). Reemplazan las flechas que iban encima de la imagen principal. */
    var thumbsPrev = gallery.querySelector('[data-thumbs-prev]');
    var thumbsNext = gallery.querySelector('[data-thumbs-next]');
    if (thumbsPrev) thumbsPrev.addEventListener('click', function() { goToSlide(currentIndex - 1); });
    if (thumbsNext) thumbsNext.addEventListener('click', function() { goToSlide(currentIndex + 1); });

    /* Touch swipe */
    var startX = 0;
    var mainEl = gallery.querySelector('.product-gallery__main');
    if (mainEl) {
      mainEl.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
      mainEl.addEventListener('touchend', function(e) {
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          goToSlide(diff > 0 ? currentIndex + 1 : currentIndex - 1);
        }
      }, { passive: true });
    }

    /* ===== Zoom lightbox (P3.5-3) ===== */
    var zoomDialog = gallery.querySelector('[data-gallery-zoom]');
    if (zoomDialog && typeof zoomDialog.showModal === 'function') {
      var zoomImage = zoomDialog.querySelector('[data-zoom-image]');
      var zoomDots = zoomDialog.querySelectorAll('[data-zoom-dot]');

      function showZoom(index) {
        var img = slides[index] && slides[index].querySelector('.product-gallery__image');
        if (!img) return;
        zoomImage.src = img.getAttribute('data-zoom-src') || img.src;
        zoomImage.alt = img.alt || '';
        zoomDots.forEach(function(d, i) { d.classList.toggle('is-active', i === index); });
      }

      zoomDots.forEach(function(dot) {
        dot.addEventListener('click', function(e) {
          e.stopPropagation();
          var i = parseInt(dot.getAttribute('data-zoom-dot'), 10) || 0;
          goToSlide(i);
          showZoom(i);
        });
      });

      gallery.querySelectorAll('.product-gallery__image').forEach(function(img) {
        img.addEventListener('click', function() {
          showZoom(currentIndex);
          zoomDialog.showModal();
        });
      });

      var zoomClose = zoomDialog.querySelector('[data-zoom-close]');
      if (zoomClose) zoomClose.addEventListener('click', function() { zoomDialog.close(); });

      /* Clic en imagen o backdrop cierra (salvo que venga de un swipe) */
      var zoomSwiped = false;
      zoomDialog.addEventListener('click', function(e) {
        if (zoomSwiped) { zoomSwiped = false; return; }
        if (e.target === zoomDialog || e.target === zoomImage) zoomDialog.close();
      });

      /* Swipe táctil en el lightbox (además de los chevrons) */
      var zTouchX = null;
      zoomImage.addEventListener('touchstart', function(e) { zTouchX = e.changedTouches[0].clientX; }, { passive: true });
      zoomImage.addEventListener('touchend', function(e) {
        if (zTouchX === null) return;
        var dx = e.changedTouches[0].clientX - zTouchX;
        zTouchX = null;
        if (Math.abs(dx) < 40) return; // tap, no swipe → deja cerrar
        zoomSwiped = true; // evita que el click sintético cierre el lightbox
        goToSlide(dx < 0 ? currentIndex + 1 : currentIndex - 1);
        showZoom(currentIndex);
      }, { passive: true });

      var zoomPrev = zoomDialog.querySelector('[data-zoom-prev]');
      var zoomNext = zoomDialog.querySelector('[data-zoom-next]');
      if (zoomPrev) zoomPrev.addEventListener('click', function(e) {
        e.stopPropagation();
        goToSlide(currentIndex - 1);
        showZoom(currentIndex);
      });
      if (zoomNext) zoomNext.addEventListener('click', function(e) {
        e.stopPropagation();
        goToSlide(currentIndex + 1);
        showZoom(currentIndex);
      });

      zoomDialog.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft' && zoomPrev) zoomPrev.click();
        if (e.key === 'ArrowRight' && zoomNext) zoomNext.click();
      });
    }

    /* Update gallery when variant changes */
    function updateGalleryForVariant(variantImageId) {
      if (!variantImageId) return;
      slides.forEach(function(slide, i) {
        if (slide.getAttribute('data-media-id') == variantImageId) {
          goToSlide(i);
        }
      });
    }

    window.__updateProductGallery = updateGalleryForVariant;
  }

  /* ============ Variant Selector ============ */
  var formWrapper = section.querySelector('[data-product-form-wrapper]');
  if (formWrapper) {
    var variantsJson = formWrapper.querySelector('[data-product-variants]');
    var variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
    var selectors = formWrapper.querySelectorAll('[data-option-selector]');
    var variantIdInput = formWrapper.querySelector('[data-variant-id]');
    var priceContainer = formWrapper.querySelector('[data-product-price]');
    var addToCartBtn = formWrapper.querySelector('[data-add-to-cart]');
    var skuEl = section.querySelector('[data-product-sku]');

    selectors.forEach(function(sel) {
      sel.addEventListener('change', onVariantChange);
    });

    /* ===== Disponibilidad por opción (P3.5-4) =====
       Marca valores que, combinados con el resto de la selección actual,
       resultan en variante agotada (tachado) o inexistente (atenuado). */
    var soldOutSuffix = ' — ' + ((addToCartBtn && addToCartBtn.closest('form').dataset.soldText) || 'Agotado');

    function updateOptionAvailability() {
      var selected = getSelectedOptions();

      formWrapper.querySelectorAll('input[type="radio"][data-option-selector]').forEach(function(radio) {
        var idx = parseInt(radio.dataset.optionIndex);
        var candidate = selected.slice();
        candidate[idx] = radio.value;
        var variant = findVariant(candidate);
        var label = radio.closest('.product-form__swatch');
        if (label) {
          label.classList.toggle('is-unavailable', !variant || !variant.available);
        }
      });

      formWrapper.querySelectorAll('select[data-option-selector]').forEach(function(select) {
        var idx = parseInt(select.dataset.optionIndex);
        Array.prototype.forEach.call(select.options, function(opt) {
          var candidate = selected.slice();
          candidate[idx] = opt.value;
          var variant = findVariant(candidate);
          var base = opt.dataset.baseText || opt.textContent.trim();
          opt.dataset.baseText = base;
          opt.textContent = (!variant || !variant.available) ? base + soldOutSuffix : base;
        });
      });
    }

    function getSelectedOptions() {
      var options = [];
      var selectEls = formWrapper.querySelectorAll('select[data-option-selector]');
      var radioEls = formWrapper.querySelectorAll('input[type="radio"][data-option-selector]:checked');
      var allSelectors = [];

      selectEls.forEach(function(s) { allSelectors.push({ index: parseInt(s.dataset.optionIndex), value: s.value }); });
      radioEls.forEach(function(r) { allSelectors.push({ index: parseInt(r.dataset.optionIndex), value: r.value }); });

      allSelectors.sort(function(a, b) { return a.index - b.index; });
      allSelectors.forEach(function(s) { options.push(s.value); });
      return options;
    }

    function findVariant(options) {
      return variants.find(function(v) {
        return v.options.every(function(opt, i) { return opt === options[i]; });
      });
    }

    function onVariantChange() {
      var options = getSelectedOptions();
      var variant = findVariant(options);
      if (!variant) return;

      /* Update hidden input */
      if (variantIdInput) variantIdInput.value = variant.id;

      /* Update URL */
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      /* Update price */
      if (priceContainer) {
        var html = '';
        var formattedPrice = formatMoney(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          var saveMoney = formatMoney(variant.compare_at_price - variant.price);
          var saveTpl = priceContainer.dataset.saveLabel || 'Ahorras [amount]';
          html = '<div class="product-form__price-main">'
            + '<s class="product-form__price--compare">' + formatMoney(variant.compare_at_price) + '</s>'
            + '<span class="product-form__price--sale">' + formattedPrice + '</span>'
            + '<span class="product-form__price--badge">-' + pct + '%</span>'
            + '</div>'
            + '<span class="product-form__price-save">' + saveTpl.replace('[amount]', saveMoney) + '</span>';
        } else {
          html = '<span class="product-form__price--regular">' + formattedPrice + '</span>';
        }
        priceContainer.innerHTML = html;

        /* Precio de la barra fija inferior */
        var barPrice = section.querySelector('[data-pdp-bar-price]');
        if (barPrice) barPrice.textContent = formattedPrice.replace(/<[^>]*>/g, '');
      }

      /* Monto por cuota del widget de Mercado Pago. El widget vigila sus propios
         atributos, así que con reescribirlos se redibuja solo. Los espera en
         pesos enteros: él los formatea. */
      var mpWidget = formWrapper.querySelector('[data-mercado-pago-widget]');
      if (mpWidget && mpWidget.dataset.mpAmounts === 'true') {
        (mpWidget.getAttribute('cuotas') || '').split(',').forEach(function (cuota) {
          var n = parseInt(cuota, 10);
          if (n > 0) {
            mpWidget.setAttribute('monto-' + n + '-cuotas', Math.floor(variant.price / 100 / n));
          }
        });
      }

      /* Update add to cart button. Si el botón se convirtió en stepper
         (cart.js, tras agregar), al cambiar de variante volvemos al botón:
         el stepper controla la línea de la variante ANTERIOR. */
      var pdpStepper = formWrapper.querySelector('[data-card-stepper][data-pdp]');
      if (pdpStepper) {
        var form = pdpStepper.closest('form');
        var btnHtml = '<button type="submit" class="btn btn-primary product-form__submit" data-add-to-cart></button>';
        var temp = document.createElement('div');
        temp.innerHTML = btnHtml;
        var newBtn = temp.firstElementChild;
        pdpStepper.replaceWith(newBtn);
        addToCartBtn = newBtn;
      } else {
        addToCartBtn = formWrapper.querySelector('[data-add-to-cart]');
      }
      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        addToCartBtn.textContent = variant.available ? addToCartBtn.closest('form').dataset.addText || 'Add to cart' : addToCartBtn.closest('form').dataset.soldText || 'Sold out';
      }

      /* Agotado: mostrar bloque de alternativas (deseos + asesor, QAM-2) */
      var soldoutExtra = formWrapper.querySelector('[data-soldout-extra]');
      if (soldoutExtra) soldoutExtra.hidden = variant.available;

      /* Update SKU */
      if (skuEl) skuEl.textContent = variant.sku || '';

      /* Update gallery */
      if (window.__updateProductGallery && variant.featured_image) {
        window.__updateProductGallery(variant.featured_image.id);
      }

      /* Re-marcar disponibilidad de opciones */
      updateOptionAvailability();

      /* Tope de inventario (P3.5-8) */
      updateQtyMax(variant.id);
    }

    /* ===== Tope de inventario (P3.5-8) ===== */
    var inventoryJson = formWrapper.querySelector('[data-product-inventory]');
    var inventoryMap = inventoryJson ? JSON.parse(inventoryJson.textContent) : {};

    function updateQtyMax(variantId) {
      var input = formWrapper.querySelector('[data-qty-input]');
      if (!input) return;
      var max = inventoryMap[String(variantId)];
      if (typeof max === 'number' && max > 0) {
        input.max = max;
        if (parseInt(input.value) > max) input.value = max;
      } else {
        input.removeAttribute('max');
      }
    }

    /* Estado inicial */
    updateOptionAvailability();
    if (variantIdInput) updateQtyMax(variantIdInput.value);

  }

  /* ============ Quantity Buttons ============ */
  var qtyMinus = section.querySelector('[data-qty-minus]');
  var qtyPlus = section.querySelector('[data-qty-plus]');
  var qtyInput = section.querySelector('[data-qty-input]');

  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyPlus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      var max = parseInt(qtyInput.max);
      qtyInput.value = (max && val >= max) ? max : val + 1;
    });
  }

  /* ============ Tabs — sticky scrollspy ============ */
  var tabsEl = section.querySelector('[data-product-tabs]');
  if (tabsEl) {
    var tabs = tabsEl.querySelectorAll('[data-tab]');
    var panels = tabsEl.querySelectorAll('[data-tab-panel]');
    var navEl = tabsEl.querySelector('.product-tabs__nav');

    function getHeaderHeight() {
      const header = document.querySelector('.header');
      return header ? header.offsetHeight : 0;
    }

    /* Abre una subpestaña del widget de Judge.me (está oculta: la accionan las
       pestañas del tema). Se identifica por el texto configurado en el propio
       widget —viene traducido— y se cae a la posición como respaldo. Reintenta
       unos instantes porque el widget carga asíncrono. */
    function abrirSubpestanaJudgeme(cual, intentos) {
      intentos = intentos == null ? 12 : intentos;
      var pestanas = document.querySelectorAll('#judgeme_product_reviews .jdgm-tab');
      if (!pestanas.length) {
        if (intentos > 0) setTimeout(function () { abrirSubpestanaJudgeme(cual, intentos - 1); }, 250);
        return;
      }
      var esPregunta = cual === 'questions';
      var patron = esPregunta ? /pregunt|question/i : /rese|review/i;
      var objetivo = null;
      pestanas.forEach(function (p) {
        if (!objetivo && patron.test(p.textContent)) objetivo = p;
      });
      if (!objetivo) objetivo = pestanas[esPregunta ? 1 : 0];
      if (objetivo && objetivo.className.indexOf('--active') === -1) objetivo.click();
    }

    /* Marca una sola pestaña. El indicador lo decide normalmente el scroll,
       pero al hacer clic hay que fijarlo de inmediato: si no, el observador
       marcaba la pestaña del panel visible y quedaban dos subrayadas. */
    function marcarTab(tab) {
      tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
    }

    /* Mientras dura el scroll suave manda la elección del usuario, no el
       observador; después vuelve a mandar el scroll. */
    var seleccionManual = false;
    var temporizadorSeleccion;

    /* Clic en tab → smooth scroll al panel */
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = this.getAttribute('data-tab');

        marcarTab(this);
        seleccionManual = true;
        clearTimeout(temporizadorSeleccion);
        temporizadorSeleccion = setTimeout(function () { seleccionManual = false; }, 900);

        /* Reseñas y Preguntas comparten panel: cada una abre además su
           subpestaña en el widget, para poder ir y volver entre ambas. */
        if (this.hasAttribute('data-jdgm-questions')) {
          target = 'reviews';
          abrirSubpestanaJudgeme('questions');
        } else if (target === 'reviews') {
          abrirSubpestanaJudgeme('reviews');
        }
        var panel = tabsEl.querySelector('[data-tab-panel="' + target + '"]');
        if (!panel) return;

        var headerHeight = getHeaderHeight();
        var navHeight = navEl ? navEl.offsetHeight : 0;

        // El offset debe ser: posición del panel - header - nav + 1px de margen para activar el observer
        var offset = panel.getBoundingClientRect().top + window.scrollY - headerHeight - navHeight + 2;

        window.scrollTo({ top: offset, behavior: 'smooth' });
      });
    });


    /* IntersectionObserver → actualiza tab activo al hacer scroll */
    // Calculamos el rootMargin basado en la altura del header + nav
    function updateObserver() {
      if (window.productTabObserver) window.productTabObserver.disconnect();

      var headerHeight = getHeaderHeight();
      var navHeight = navEl ? navEl.offsetHeight : 0;
      var topMargin = headerHeight + navHeight;

      window.productTabObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            /* Si el usuario acaba de elegir una pestaña, respetar su elección */
            if (seleccionManual) return;

            var panelId = entry.target.getAttribute('data-tab-panel');
            /* Reseñas y Preguntas comparten panel: se marca una u otra según
               qué subpestaña del widget esté abierta. */
            var subActiva = document.querySelector('#judgeme_product_reviews .jdgm-tab--active');
            var enPreguntas = panelId === 'reviews' && subActiva
              && /pregunt|question/i.test(subActiva.textContent);
            var elegida = null;
            tabs.forEach(function(t) {
              var suyo = t.getAttribute('data-tab');
              var activo = suyo === panelId;
              if (panelId === 'reviews') {
                activo = enPreguntas ? suyo === 'questions' : suyo === 'reviews';
              }
              if (activo) elegida = t;
            });
            if (elegida) marcarTab(elegida);

            // Scroll horizontal del nav para mantener tab visible
            var activeTab = Array.from(tabs).find(t => t.getAttribute('data-tab') === panelId);
            if (activeTab && navEl) {
              var tabLeft = activeTab.offsetLeft;
              var tabWidth = activeTab.offsetWidth;
              var navWidth = navEl.offsetWidth;
              navEl.scrollTo({ left: tabLeft - (navWidth / 2) + (tabWidth / 2), behavior: 'smooth' });
            }
          }
        });
      }, {
        // El área de detección empieza justo debajo de la barra de pestañas
        rootMargin: '-' + (topMargin + 10) + 'px 0px -60% 0px',
        threshold: 0
      });

      panels.forEach(function(panel) { window.productTabObserver.observe(panel); });
    }

    updateObserver();
    window.addEventListener('resize', ThemeUtils.debounce(updateObserver, 200));
  }

  /* ============ Barra fija inferior de compra ============
     Aparece apenas el BOTÓN de agregar sale del viewport hacia arriba (no
     cuando todavía no se llegó a él). Se observa .product-form__actions —el
     contenedor del CTA— y no el botón en sí, porque cart.js lo reemplaza por
     el stepper al agregar; el contenedor sobrevive a ese reemplazo. */
  var pdpBar = section.querySelector('[data-pdp-bar]');
  var buyBlock = section.querySelector('.product-form__actions')
    || section.querySelector('[data-product-form-wrapper]');

  if (pdpBar && buyBlock && 'IntersectionObserver' in window) {
    var showBar = function (visible) {
      pdpBar.classList.toggle('is-visible', visible);
      pdpBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      /* Alto real → lo usa el botón de WhatsApp para apartarse */
      if (visible) {
        document.documentElement.style.setProperty('--pdp-bar-height', pdpBar.offsetHeight + 'px');
      }
    };

    /* rootMargin descuenta el header sticky: el botón deja de verse cuando pasa
       DETRÁS del header, no cuando cruza el borde del viewport. Sin esto la
       barra tardaba de más en salir. */
    var headerH = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10
    ) || 60;

    new IntersectionObserver(function (entries) {
      var e = entries[0];
      showBar(!e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0, rootMargin: '-' + headerH + 'px 0px 0px 0px' }).observe(buyBlock);

    /* Agrega llamando al carrito directamente, sin simular clics en otros
       elementos. Antes buscaba `[data-step="up"]` —un atributo que no existe en
       el tema— y solo funcionaba de rebote por un segundo selector basado en
       `:last-child`: si cambiaba el orden del stepper, el botón dejaba de
       responder sin que nada lo delatara. */
    var barAdd = pdpBar.querySelector('[data-pdp-bar-add]');
    if (barAdd) {
      barAdd.addEventListener('click', function () {
        if (barAdd.disabled) return;
        var form = section.querySelector('form[data-product-form]');
        var input = form && form.querySelector('[data-variant-id]');
        var variantId = input && input.value;
        if (!variantId || !window.addToCart) return;

        barAdd.disabled = true;
        barAdd.classList.add('is-loading');
        window.addToCart(variantId, 1)
          .catch(function () {})
          .then(function () {
            barAdd.disabled = false;
            barAdd.classList.remove('is-loading');
          });
      });
    }
  }

  /* ============ Share (con feedback de copiado, P3.5-9) ============ */
  var shareBtn = section.querySelector('[data-share-btn]');
  if (shareBtn) {
    shareBtn.addEventListener('click', function() {
      if (navigator.share) {
        navigator.share({ title: document.title, url: window.location.href }).catch(function() {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(window.location.href).then(function() {
          var original = shareBtn.innerHTML;
          shareBtn.textContent = shareBtn.dataset.copiedText || 'Enlace copiado';
          setTimeout(function() { shareBtn.innerHTML = original; }, 2000);
        });
      }
    });
  }

  /* ============ Shopify Recommendations (Section Rendering API) ============ */
  /* Las cards llegan ya renderizadas con el snippet 'product-card' real
     (sections/product-recommendations.liquid) — un solo markup, una sola fuente. */
  function loadRecommendations(container, productId, limit, intent) {
    var url = '/recommendations/products?section_id=product-recommendations&product_id=' + productId + '&limit=' + limit + '&intent=' + intent;
    fetch(url)
      .then(function(res) {
        if (!res.ok) throw new Error('Recommendations fetch failed');
        return res.text();
      })
      .then(function(html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var output = temp.querySelector('[data-recommendations-output]');
        if (!output || output.children.length === 0) return;
        var grid = container.querySelector('[data-recommendations-grid], [data-complementary-grid]');
        if (!grid) return;
        grid.innerHTML = output.innerHTML;
        container.style.display = '';
      })
      .catch(function() {});
  }

  var recSection = section.querySelector('[data-recommendations-section]');
  if (recSection) {
    loadRecommendations(
      recSection,
      recSection.dataset.productId,
      recSection.dataset.limit || 8,
      'related'
    );
  }

  var compSection = section.querySelector('[data-complementary-section]');
  if (compSection) {
    loadRecommendations(
      compSection,
      compSection.dataset.productId,
      compSection.dataset.limit || 4,
      'complementary'
    );
  }
})();
